import React from 'react'
import { airdropDate } from 'src/views/Home/components/Activitys/Airdrop/hooks/WhiteUser'

function useActivityNotStart() {
  return Math.floor(Date.now() / 1000) < airdropDate
}

export default useActivityNotStart